import { CategoryData, Co2Aggregates2, ElementData, Model, ModelData, Project, Scenario, ScenarioData } from "@api/apiClient";

// NOTE: you can extend apiClient classes with extra fields here for type safety.
// This is a good place to add computed properties.
declare module "./apiClient" {
  export interface Element {
    path: string[];
    siblings?: number;
    label?: string;
    material?: Material; // TODO: add these back in as navigation properties
    cadModelCategory?: CadModelCategory; // TODO: add these back in as navigation properties
  }

  export interface Component {
    material?: Material; // TODO: add these back in as navigation properties
    cadModelCategory?: CadModelCategory; // TODO: add these back in as navigation properties
  }

  export interface Supplemental {
    material?: Material; // TODO: add these back in as navigation properties
  }

    export interface CategoryData {
    getInScopeTotalCo2(fields: string[]): number | null;
  }

  export interface ElementDto {
    path: string[];
    siblings?: number;
    label?: string;
    material?: Material; // TODO: add these back in as navigation properties
  }

  export interface ElementData {
    hexColor?: string;
    bucketIndex?: number;
    getInScopeTotalCo2(fields: string[]): number | null;
  }

  export interface ModelData {
    getInScopeTotalCo2(fields: string[]): number | null;
  }

  export interface Project {
    get hasModels(): boolean;
    getModelUrn(modelId: string): string | undefined;
  }

  export interface Scenario {
    getPercentageAssigned(): number;
  }

  export interface ScenarioData {
    getPercentageAssigned(): number;
  }

  export type ModelExtendedDataDto = { [key: string]: { [key: string]: any; }; } | undefined;
}

// NOTE: you can extend apiClient classes with extra methods here.
// For getters & setters see Object.defineProperty()

(function () {
  if (!Project.prototype.hasOwnProperty.call(Object.prototype, "hasModels")) {
    Object.defineProperty(Project.prototype, "hasModels", {
      enumerable: true,
      configurable: true,
      get: function () {
        return (this.models?.length || 0) > 0;
      },
    });
  }
})();

Project.prototype.getModelUrn = function (modelId: string) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self: Project = this;
  return self.models?.find((model: Model) => model.modelId === modelId)?.apsViewId;
};

Scenario.prototype.getPercentageAssigned = function () {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self: Scenario = this;
  if (self.scenarioModels && self.scenarioModels.length > 0) {
    let result =
      self.scenarioModels?.reduce((acc, scenarioModel) => {
        return (acc += scenarioModel?.percentageAssign || 0);
      }, 0) || 0;
    result = result / self.scenarioModels?.length;
    return result;
  } else {
    return 0;
  }
};

/**
 * Get the total CO2 emissions for the element within the specified fields.
 * @param fields (optional) an array of A-D field names used to calculate the in-scope total CO2 emissions.
 * valid values are: 'a1A2A3', 'a4', 'a5', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'c1', 'c2', 'c3', 'c4', 'd', 'biogenic'
 */
ModelData.prototype.getInScopeTotalCo2 = function (fields: string[] = ["totalCo2"]) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self: ModelData = this;
  return fields.reduce((acc: number | null, field: string) => {
    if (self.co2Aggregates?.[field as keyof Co2Aggregates2] == null) {
      return acc;
    }
    const value = self.co2Aggregates?.[field as keyof Co2Aggregates2] as number | null;
    return (acc || 0) + (value || 0);
  }, null);
};

/**
 * Get the total CO2 emissions for the element within the specified fields.
 * @param fields (optional) an array of A-D field names used to calculate the in-scope total CO2 emissions.
 * valid values are: 'a1A2A3', 'a4', 'a5', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'c1', 'c2', 'c3', 'c4', 'd', 'biogenic'
 */
CategoryData.prototype.getInScopeTotalCo2 = function (fields: string[] = ["totalCo2"]) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self: CategoryData = this;
  return fields.reduce((acc: number | null, field: string) => {
    if (self.co2Aggregates?.[field as keyof Co2Aggregates2] == null) {
      return acc;
    }
    const value = self.co2Aggregates?.[field as keyof Co2Aggregates2] as number | null;
    return (acc || 0) + (value || 0);
  }, null);
};

ScenarioData.prototype.getPercentageAssigned = function () {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self: ScenarioData = this;
  if (self.modelDatas && self.modelDatas.length > 0) {
    let result =
      self.modelDatas?.reduce((acc, modelData) => {
        return (acc += modelData?.percentageAssign || 0);
      }, 0) || 0;
    result = result / self.modelDatas?.length;
    return result;
  } else {
    return 0;
  }
};

/**
 * Get the total CO2 emissions for the element within the specified fields.
 * @param fields (optional) an array of A-D field names used to calculate the in-scope total CO2 emissions.
 * Valid values are: 'a1A2A3', 'a4', 'a5', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'c1', 'c2', 'c3', 'c4', 'd', 'biogenic'
 */
ElementData.prototype.getInScopeTotalCo2 = function (fields: string[] = ["totalCo2"]) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self: ElementData = this;
  return fields.reduce((acc: number | null, field: string) => {
    if (self.co2Aggregates?.[field as keyof Co2Aggregates2] == null) {
      return acc;
    }
    const value = self.co2Aggregates?.[field as keyof Co2Aggregates2] as number | null;
    return (acc || 0) + (value || 0);
  }, null);
};